import { Component, inject, Input, computed } from '@angular/core';
import { OrderInvoicingStatusState } from '../../services/order-invoicing-status.state';
import { CommonModule } from '@angular/common';
import { HorusLoaderComponent } from '@shared/components/domain/horus-loader/horus-loader.component';
import dayjs from 'dayjs';

@Component({
  selector: 'app-order-invoicing-status',
  standalone: true,
  imports: [CommonModule, HorusLoaderComponent],
  templateUrl: './order-invoicing-status.component.html',
  styleUrl: './order-invoicing-status.component.scss',
  providers: [OrderInvoicingStatusState]
})
export class OrderInvoicingStatusComponent {

  readonly state = inject(OrderInvoicingStatusState);

  readonly formattedDate = computed(() => {
    const date = this.state.invoicedDate();
    if (!date) return '';
    return dayjs(date).format('DD/MM/YY');
  });

  @Input()
  set tenantId(value: string | null) {
    this.state.tenantId.set(value);
  }

  @Input()
  set orderId(value: string | null) {
    this.state.orderId.set(value);
  }
}
